import { HttpClientRepository } from "@data/repositories/index";
import { ToggleSpecialIconUseCase } from "@useCases/index";
import { api } from "@data/api";
import { Client } from "@domain/models/Client";

export default function useSpecialIcon() {
  const toggleSpecialIcon = (clientId: Client["id"]) => {
    const useCase = new ToggleSpecialIconUseCase(new HttpClientRepository(api));

    useCase.execute(clientId);
  };

  return { toggleSpecialIcon };
}
